module.exports = __webpack_public_path__ + "static/media/Q-Spades.25b35525.svg";